var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c(
        "b-card",
        [
          _c("FormReportingChannel", {
            ref: "form",
            attrs: {
              id: _vm.id,
              "request-form": _vm.requestForm,
              title: _vm.$t("reporting_channel.screening"),
              "show-history": false
            }
          }),
          _c(
            "b-row",
            { staticClass: "m-0 mt-2" },
            [
              _c(
                "b-col",
                { attrs: { lg: "12" } },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.saveScreening($event)
                        }
                      }
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "m-0" },
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c("validation-provider", {
                                staticClass: "flex-grow",
                                attrs: {
                                  name: _vm.$t(
                                    "reporting_channel.severity_level"
                                  ),
                                  rules: "required",
                                  slim: ""
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(validationContext) {
                                      return [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "reporting_channel.severity_level"
                                              ),
                                              "label-for": "severity_level"
                                            }
                                          },
                                          [
                                            _c("b-form-select", {
                                              staticClass: "required-select",
                                              attrs: {
                                                id: "severity_level",
                                                options: _vm.listSeverityLevels,
                                                "text-field": "label",
                                                "value-field": "key"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "first",
                                                    fn: function() {
                                                      return [
                                                        _c(
                                                          "b-form-select-option",
                                                          {
                                                            attrs: {
                                                              value: null,
                                                              disabled: ""
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "-- Selecione uma opção --"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                true
                                              ),
                                              model: {
                                                value: _vm.modelSeverityLevel,
                                                callback: function($$v) {
                                                  _vm.modelSeverityLevel = $$v
                                                },
                                                expression: "modelSeverityLevel"
                                              }
                                            }),
                                            _c(
                                              "b-form-invalid-feedback",
                                              {
                                                class: [
                                                  { absolute: _vm.inline }
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      validationContext
                                                        .errors[0]
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        { staticClass: "m-0" },
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.screening"
                                    ),
                                    "label-for": "treatment"
                                  }
                                },
                                [
                                  _c("simple-editor", {
                                    staticClass: "mb-2",
                                    model: {
                                      value: _vm.textTreatment,
                                      callback: function($$v) {
                                        _vm.textTreatment = $$v
                                      },
                                      expression: "textTreatment"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("div", { staticClass: "mt-1 mb-2" }, [
                        _c(
                          "div",
                          { staticClass: "flex justify-end" },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(255, 255, 255, 0.15)",
                                    expression: "'rgba(255, 255, 255, 0.15)'",
                                    modifiers: { "400": true }
                                  }
                                ],
                                staticClass: "mt-1 mr-1 float-right",
                                attrs: {
                                  variant: "primary",
                                  disabled: !_vm.validateForm
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.saveScreening()
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]
                            ),
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(255, 255, 255, 0.15)",
                                    expression: "'rgba(255, 255, 255, 0.15)'",
                                    modifiers: { "400": true }
                                  }
                                ],
                                staticClass: "mt-1 mr-1 float-right",
                                attrs: { variant: "outline-secondary" },
                                on: {
                                  click: function($event) {
                                    return _vm.$router.push(
                                      "/reporting-channel/screening"
                                    )
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("back")) + " ")]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }